<template>
  <div style="display: flex; justify-content: center; height: 100%;">
    <div :class="`${classVariableName}-carousel-container`" style="height: 100%;">
      <div :class="`${classVariableName}-carousel`">
        <div :class="`${classVariableName}-carousel-images`"
          :style="{ height: 'max-content', transform: 'translateX(-' + currentIndex * 100 + '%)' }">
          <div style="display: flex;">
            <img loading="lazy" :class="`${classVariableName}-image ${classVariableName}-carousel-single-image`"
              v-for="(image, index) in images" :key="index" :src="image.lowResUrl" :alt="'Image ' + (index + 1)" />
          </div>
        </div>
        <button :class="`${classVariableName}-prev-button ${classVariableName}-mob-button`">
          <div :class="`${classVariableName}-button-icon`" v-if="images.length > 1" @click="prevImage">
            <Arrow :direction="'left'" kind="invert" />
          </div>
        </button>
        <button :class="`${classVariableName}-next-button ${classVariableName}-mob-button`">
          <div :class="`${classVariableName}-button-icon`" v-if="images.length > 1" @click="nextImage">
            <Arrow :direction="'right'" kind="invert" />
          </div>
        </button>
        <div :class="`${classVariableName}-mob-thumb-div`">
          <div v-if="images.length > 1" :class="`${classVariableName}-mob-thumbnails`">
            <div :class="`${classVariableName}-img-container ${classVariableName}-cursor-pointer`" :style="{border: 'none'}"
              v-for="(image, index) in images" :key="index">
              <img :style="{ width: '52px', height: '52px' }" loading="lazy" :src="image.lowResUrl"
                :class="`${classVariableName}-image ${index === currentIndex?'active':''}`" @click="showImage(index)">
            </div>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { classVariableName } from "../../utils";
import Arrow from "../common/Arrow.vue";

export default defineComponent({
  props: {
    images: Array,
    currentIndex: Number,
  },
  components: {
    Arrow,
  },
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
  methods: {
    nextImage() {
      if (this.images.length <= 1) return;
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
      }
    },
    prevImage() {
      if (this.images.length <= 1) return;
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    showImage(index) {
      this.currentIndex = index;
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/App.scss";
</style>
